<template>
  <div>
    <span
      v-if="mode !== 'form'"
      style="margin-left: 1.5em; margin-right: 3.5em; fontsize: 14px"
      class="has-text-grey"
    >
      {{ setting.label || name }}
    </span>
    <el-select
      :name="setting.label || name"
      :clearable="setting.clearable"
      allow-create
      filterable
      multiple
      v-model="value[name]"
      placeholder="Create list"
      style="margin-bottom: 1em; width: 360px"
    >
      <el-option
        v-for="(item, index) in setting.default"
        :key="index"
        :label="item"
        :value="item"
      />
    </el-select>

    <Tooltip :label="setting.label || name" :content="setting.detail" />
  </div>
</template>

<script>
/**
 * SmartFieldList - Multi-select dropdown with custom value creation for array configuration.
 *
 * @component
 * @description Renders a filterable multi-select dropdown that allows users to create new values on the fly.
 * Users can either select from default options or type to create new custom values.
 * Particularly useful for tag-like inputs where the set of values is not fixed.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the select (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {boolean} [setting.clearable] - If true, allows clearing the selection
 * @prop {Array<string>} [setting.default] - Array of default options and initial values
 * @prop {string} name - Property key in the value object (should be an array)
 * @prop {string} [mode] - Display mode ('form' hides label)
 *
 * @example
 * <SmartFieldList
 *   :value="config"
 *   :setting="{
 *     label: 'Allowed Domains',
 *     detail: 'Enter allowed domains',
 *     default: ['example.com', 'test.com'],
 *     clearable: true
 *   }"
 *   name="allowedDomains"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name", "mode"],
  mounted() {
    if (_.isEmpty(this.value[this.name])) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
